import React, {Component} from 'react';
import {HEADER_HEIGHT} from "../../../constants";
import {Button} from "antd";
import nodata from "../image/noData.png"

class NotColumnPage extends Component {

    render() {
        let mediaId = this.props.match.params.mediaId ? this.props.match.params.mediaId : '';
        return (
            <table width={"100%"} cellSpacing={0} cellPadding={0} border={0} style={{margin: 15, borderRadius: 5,height:document.body.clientHeight - HEADER_HEIGHT - 15 * 2, background:"#fff"}}>
                <tr><td align={"center"} valign={"middle"}>
                   <div>
                   <img src={nodata}/>
                    <p>暂无栏目数据</p>
                   </div>
                </td></tr>
            </table>
        );
    }
}

export default NotColumnPage;
